module.exports = __webpack_public_path__ + "img/8.fe56540b.png";